import { placeholderNumbers } from "./templates/templateFormat";

// The template types a stage can send: their sends fill a body and, for a file, carry its link.
export const STAGE_TEMPLATE_TYPES = ["text", "image", "video", "document"];

// Templates made on the Templates tab that a stage can use: the whole brand's (not one dealer's),
// of a type a stage can send, and not turned down by Meta.
export function stageTemplates(rows) {
  return (rows || []).filter(
    (r) => r.dealer_id == null && STAGE_TEMPLATE_TYPES.includes(r.template_type || "text") && (r.status === "approved" || r.status === "pending"),
  );
}

// The labels of a template's reply buttons: what a customer can tap.
export function replyButtons(template) {
  return (template?.buttons || []).filter((b) => (b.type || "QUICK_REPLY") === "QUICK_REPLY" && b.text).map((b) => b.text);
}

// True when every {{n}} in the chosen template has a field.
export function pickComplete(pick, templates) {
  if (!pick) return true;
  const t = templates.find((x) => x.id === pick.id);
  if (!t) return false;
  return placeholderNumbers(t.body).every((n) => (t.field_map || {})[n] || (pick.field_map || {})[n]);
}
